// src/SimpleInterestCalculator.js
import React, { useState } from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import FAQSchema from '../../FAQSchema';
import AdBanner from '../AdPage/AdBanner';

// Register necessary components
ChartJS.register(
  ArcElement,
  ChartTooltip,
  Legend
);

const SimpleInterestCalculator = () => {
  const [principalAmount, setPrincipalAmount] = useState(10000);
  const [interestRate, setInterestRate] = useState(5);
  const [timePeriod, setTimePeriod] = useState(2);
  const [totalInterest, setTotalInterest] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);

  const calculateSimpleInterest = () => {
    const interest = (principalAmount * interestRate * timePeriod) / 100;
    const amount = principalAmount + interest;

    setTotalInterest(interest.toFixed(2));
    setTotalAmount(amount.toFixed(2));
  };

  const handlePrincipalAmountChange = (e) => {
    const value = e.target.value;
    setPrincipalAmount(value === '' ? 0 : parseInt(value));
  };

  const handleInterestRateChange = (e) => {
    const value = e.target.value;
    setInterestRate(value === '' ? 0 : parseFloat(value));
  };

  const handleTimePeriodChange = (e) => {
    const value = e.target.value;
    setTimePeriod(value === '' ? 0 : parseInt(value));
  };

  const data = {
    labels: ['Principal Amount', 'Total Interest'],
    datasets: [
      {
        label: 'Simple Interest Breakdown',
        data: [principalAmount, totalInterest],
        backgroundColor: ['#36A2EB', '#FF6384'],
      },
    ],
  };
function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  
    const [activeIndex, setActiveIndex] = useState(0);
  
     
    const faqs = [
      {
        question: 'What is the formula used in the simple interest calculator?',
        answer: 'The calculator uses the standard SI formula: (Principal × Rate × Time) ÷ 100.',
      },
      {
        question: 'Can this calculator be used for loans as well?',
        answer: 'Yes, it’s perfect for calculating interest on short-term loans, especially where compound interest doesn’t apply.',
      },
      {
        question: 'How is simple interest different from compound interest?',
        answer: 'Simple interest is calculated only on the principal, while compound interest includes interest on previously earned interest.',
      },
      {
        question: 'Is the maturity amount inclusive of principal?',
        answer: 'Yes. Maturity value = Principal + Interest Earned.',
      },
      {
        question: 'Can I calculate interest for less than a year?',
        answer: 'Yes. You can use decimal values for the time period, e.g., 0.5 for six months.',
      },
      {
        question: 'Is this calculator suitable for fixed deposits?',
        answer: 'Some fixed deposits offer simple interest, especially for short terms. For compounded FDs, use our FD calculator instead.',
      },
      {
        question: 'Is interest calculated monthly or annually?',
        answer: 'This calculator assumes annual interest rates. For monthly calculations, convert accordingly.',
      },
      {
        question: 'Does this tool account for taxes?',
        answer: 'No. This calculator shows gross interest. Use our tax planner to estimate post-tax returns.',
      },
      {
        question: 'Can I calculate interest earned in recurring deposits?',
        answer: 'Recurring deposits usually use compound interest. Use our RD calculator for those.',
      },
      {
        question: 'Can this calculator be used for child education fund planning?',
        answer: 'Yes, especially for short-term deposits or trust funds earning simple interest.',
      },
      {
        question: 'What happens if the interest rate changes during the term?',
        answer: 'Simple interest is fixed. This calculator doesn’t account for rate fluctuations.',
      },
      {
        question: 'Is this tool mobile-friendly?',
        answer: 'Yes. TheFinMaster calculators are responsive across devices for easy use.',
      },
      {
        question: 'Can I save or share the calculation results?',
        answer: 'Yes, you can take a screenshot or copy the results manually. Soon, we’ll enable export options.',
      },
      {
        question: 'Does the calculator support international currencies?',
        answer: 'Currently, the tool is INR-focused, but the logic remains the same across currencies.',
      },
      {
        question: 'What’s the best tenure to earn high returns through simple interest?',
        answer: 'There’s no “best,” but longer tenures and higher principal offer higher interest. However, for higher returns, compound interest is more effective.',
      },
    ];
    const toggleAccordion = (index) => {
      if (activeIndex === index) {
          // If the clicked question is already expanded, collapse it
          setActiveIndex(null);
      } else {
          // If the clicked question is not expanded, expand it
          setActiveIndex(index);
      };
    }
  return (
    <>
     <Helmet>
         <title>Simple Interest Calculator – Interest & Final Amount Estimator</title>
        <meta  name='description' content='Quickly calculate simple interest and final amount for your deposits or loans using this simple interest calculator.'/>
        <meta name='keywords' content='simple interest calculator, basic interest calculator, compound interest simple formula, formula simple interest and compound interest, interest calculator simple interest, simple interest compound interest formula' />
        <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/simple-interest-calculator" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      {/* <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
      <ol className="list-none p-0 inline-flex">
        <li className="flex items-center">
          <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
        <li className="flex items-center">
          <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
          <li className="flex items-center">
          <span className="text-gray-500 ">Simple Interest Calculator</span>
        </li> 
      
      </ol>
    </nav> */}
       <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
    <div className='py-4'>
    <div className="container mx-auto p-4 shadow-xl rounded-md ">
      <h1 className="text-2xl font-bold mb-4">Simple Interest Calculator</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Principal Amount</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                value={principalAmount}
                onChange={handlePrincipalAmountChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">₹ {principalAmount.toLocaleString()}</span>
            </div>
            <input
              type="range"
              min="0"
              max="10000000"
              value={principalAmount}
              onChange={(e) => setPrincipalAmount(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Rate of Interest (P.A.)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="100"
                step="0.1"
                value={interestRate}
                onChange={handleInterestRateChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{interestRate} %</span>
            </div>
            <input
              type="range"
              min="0"
              max="100"
              step="0.1"
              value={interestRate}
              onChange={(e) => setInterestRate(parseFloat(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Time Period (Years)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="50"
                value={timePeriod}
                onChange={handleTimePeriodChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{timePeriod} Yr</span>
            </div>
            <input
              type="range"
              min="0"
              max="50"
              value={timePeriod}
              onChange={(e) => setTimePeriod(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <button
            onClick={calculateSimpleInterest}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Calculate
          </button>
        </div>
        <div>
          <div className="mb-4">
            <h2 className="text-xl font-bold">Results</h2>
            <p>Principal Amount: ₹ {principalAmount.toLocaleString()}</p>
            <p>Total Interest: ₹ {parseFloat(totalInterest).toLocaleString()}</p>
            <p>Total Amount (Principal + Interest): ₹ {parseFloat(totalAmount).toLocaleString()}</p>
          </div>
          <div>
            <h2 className="text-xl font-bold">Breakdown</h2>
            <div className="flex justify-center">
              <Pie data={data} options={{ maintainAspectRatio: false }} width={300} height={300} />
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>

    
    <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
    <div className="w-full md:w-2/3 p-4 mx-auto">
    <div className="container mx-auto py-4">
          <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            TheFinMaster’s Simple Interest Calculator: Plan Your Investments with Ease
          </h2>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Whether you're saving for short-term goals or lending money for a fixed return, understanding how your money grows through simple interest is essential. With TheFinMaster's Simple Interest Calculator, you can estimate your future earnings with clarity, speed, and confidence—no math degree required.
          </p>
</div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is Simple Interest?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Simple Interest is the most basic way your money can grow over time. It is calculated only on the original principal amount, without any compounding. This makes it easy to forecast your earnings and plan for short-term savings or lending.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The formula for simple interest is:
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Simple Interest (SI) = (P × R × T) / 100</strong>
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Where:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>P = Principal (initial amount invested or borrowed)</li>
              <li>R = Annual interest rate (in %)</li>
              <li>T = Time (in years)</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The maturity amount is the sum of the principal and the interest earned:
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Maturity Amount = Principal + Simple Interest</strong>
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why Use TheFinMaster’s Simple Interest Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Take the Guesswork Out of Financial Planning</strong>
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Doing manual calculations can lead to errors, especially when evaluating different scenarios. Our calculator offers a reliable, hassle-free way to estimate your returns.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Plan Short-Term Investments with Precision</strong>
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Simple interest is ideal for investments or loans with short tenure and fixed returns—like savings deposits, bonds, or personal lending. Knowing your returns upfront helps you:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Decide whether an offer is worth it.</li>
              <li>Set realistic savings goals.</li>
              <li>Evaluate multiple options quickly.</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Fast, Accurate, and User-Friendly</strong>
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              With just three inputs—Principal, Rate, and Tenure—you get instant results. No formulas. No spreadsheets. Just clarity.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Multiple Use Cases</strong>
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This tool isn't just for investors. You can use it to:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Calculate loan interest if you’ve lent money privately.</li>
              <li>Understand interest earned from fixed deposits or government savings schemes (where applicable).</li>
              <li>Forecast savings from school or business fund contributions.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How the Simple Interest Calculator Works
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              To use TheFinMaster's calculator:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Enter Principal:</strong> The amount you're investing or lending.</li>
              <li><strong>Enter Annual Interest Rate (%):</strong> Offered by the institution or individual.</li>
              <li><strong>Enter Time Period (in years):</strong> Duration of investment or loan.</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Once you hit 'Calculate', the tool displays:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Total Simple Interest earned</li>
              <li>Maturity Value (Principal + Interest)</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Example:</strong>
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Let’s say you invest ₹15,000 at 5% per annum for 2 years.
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using the formula:
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              SI = (15000 × 5 × 2) / 100 = ₹1,500
            </p>
            <p className="mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Maturity Value = ₹15,000 + ₹1,500 = ₹16,500
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This clear breakdown helps you understand exactly how much you’re gaining.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is the Simple Interest Formula and When is it Used?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The amount one needs to pay or receive after a certain tenure based on the interest can be calculated using the Simple Interest Formula. It is the best and simplest method of calculating interest on the principal amount and should be used:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>When one has borrowed money:</strong> To repay extra payment of interest along with the borrowed amount. The formula for simple interest can help to calculate the borrowing cost as Interest.</li>
              <li><strong>When someone lends money:</strong> If someone has given money to someone to earn Interest Income in exchange. By using the Simple Interest formula, one can easily get the extra income figure as the Interest.</li>
              <li><strong>When someone has invested money:</strong> If someone has invested their surplus money in deposits such as FD, RD or savings schemes like SSY, PPF or others, can also calculate the Interest Income with a simple interest calculator.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              When is Simple Interest Useful?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Simple interest is typically used in situations where:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>The investment or loan term is short (1–3 years).</li>
              <li>Interest isn’t compounded.</li>
              <li>You want quick, predictable returns.</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Common Use Cases Include:</strong>
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Fixed deposits with non-compounding interest</li>
              <li>School or business loans</li>
              <li>Personal loans from family/friends</li>
              <li>Short-term lending between individuals or businesses</li>
              <li>Government bonds or schemes with fixed payouts</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Key Benefits of Using a Simple Interest Calculator
            </h2>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Speed & Simplicity:</strong> Results in seconds, with no manual work.</li>
              <li><strong>Comparison Tool:</strong> Compare two or more schemes or loans instantly.</li>
              <li><strong>Risk-Free Estimation:</strong> No need to consult a financial advisor for basic interest calculations.</li>
              <li><strong>Ideal for Beginners:</strong> Perfect for students, first-time savers, and casual investors.</li>
              <li><strong>Accuracy & Transparency:</strong> No hidden assumptions or misleading outputs.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Understand the Difference: Simple Interest vs Compound Interest
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              While simple interest is easy to calculate, it doesn’t grow as fast as compound interest, which earns interest on both the principal and accumulated interest.
            </p>
            {/* <div className="overflow-x-auto mt-4">
              <table className="table-auto w-full border-collapse border border-gray-300">
                <thead className="bg-gray-800 text-white">
                  <tr>
                    <th className="px-4 py-2 text-left">Feature</th>
                    <th className="px-4 py-2 text-left">Simple Interest</th>
                    <th className="px-4 py-2 text-left">Compound Interest</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-300 text-gray-600">
                  <tr>
                    <td className="px-4 py-2">Calculation</td>
                    <td className="px-4 py-2">Only on principal</td>
                    <td className="px-4 py-2">On principal + interest</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2">Returns</td>
                    <td className="px-4 py-2">Linear growth</td>
                    <td className="px-4 py-2">Exponential growth</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2">Use Cases</td>
                    <td className="px-4 py-2">Short-term investments</td>
                    <td className="px-4 py-2">Long-term investments</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2">Complexity</td>
                    <td className="px-4 py-2">Easy to compute</td>
                    <td className="px-4 py-2">Needs formula or calculator</td>
                  </tr>
                </tbody>
              </table>
            </div> */}


                       
          <div className="max-w-4xl mx-auto overflow-hidden rounded-lg border border-gray-300 shadow mt-6">
    {/* Header */}
    <div className="hidden md:grid grid-cols-3 bg-gray-800 text-white text-sm font-semibold text-center">
      <div className="px-3 py-2 border-r">Feature</div>
      <div className="px-3 py-2 border-r">Simple Interest</div>
   
   

      <div className="px-3 py-2">	Compound Interest</div>
    </div>

    {/* Data rows for mobile (stacked) and desktop (grid) */}
    <div className="divide-y divide-gray-200 text-sm md:text-base text-gray-600 ">
      {/* Row Template */}
      {[
        {
          fet: "Calculation",
          sim: "	Only on principal",
          ct: "	On principal + interest",
         
        },
        {
          fet: "Returns",
          sim: "	Linear growth",
          ct: "	Exponential growth",
         
        }, {
          fet: "Use Cases",
          sim: "	Short-term investments",
          ct: "	Long-term investments",
         
        }, {
          fet: "Complexity",
          sim: "	Easy to compute",
          ct: "	Needs formula or calculator",
         
        },
       
      
      ].map((row, idx) => (
        <div
          key={idx}
          className="block md:grid md:grid-cols-3 hover:bg-gray-50 transition"
        >
          {/* Mobile version */}
          <div className="block md:hidden px-4 py-3">
            <p className="font-semibold">Feature <span className="font-normal">{row.fet}</span></p>
            <p className="font-semibold">	Simple Interest <span className="font-normal">{row.sim}</span></p>
            <p className="font-semibold">Compound Interest <span className="font-normal">{row.ct}</span></p>
            
          </div>

          {/* Desktop version */}
          <div className="hidden md:block px-4 py-3 border-r">{row.fet}</div>
          <div className="hidden md:block px-4 py-3 border-r">{row.sim}</div>
          
          <div className="hidden md:block px-4 py-3">{row.ct}</div>

        </div>
      ))}
    </div>
  </div>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              At TheFinMaster, we offer both Simple Interest and Compound Interest Calculators so you can choose based on your financial goal.
            </p>
          </div>

          <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Tips to Make the Most of Your Investment Using Simple Interest
            </h2>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Pick the Best Rate:</strong> A small increase in rate (say, 6% vs 5%) can lead to higher returns over time.</li>
              <li><strong>Know the Tenure:</strong> Longer durations fetch more interest—but only linearly in simple interest.</li>
              <li><strong>Negotiate in Private Lending:</strong> If you’re lending money, use this calculator to offer competitive yet fair returns.</li>
              <li><strong>Pair It With Other Tools:</strong> Use TheFinMaster's FD calculator, tax calculator, or SIP planner for more comprehensive planning.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Ready to Start Calculating?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Use TheFinMaster’s Simple Interest Calculator to forecast your earnings, test various what-if scenarios, and make financial decisions with confidence. Whether you’re lending money or planning short-term savings, our tool gives you clarity and control.
            </p>
          </div>

       
        </div>

     <div className="w-full md:w-1/3 p-4">
       <div className="bg-white shadow-md rounded-lg overflow-hidden">
         <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
           <h2 className="text-lg font-semibold ">Popular Categories</h2>
         </div>
         <div className="p-2 ">
         <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>
                         {/* Ad Banner */}
  <div className="mt-4">
    <div className="bg-white shadow-md rounded-lg overflow-hidden">
      <div className="p-3 w-full h-auto rounded-md object-cover">
        <AdBanner displayOrder="2" />
      </div>
    </div>
  </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                {/* <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link> */}
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
             {/* {moreCategories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
           </ul>
         </div>
       </div>

     </div>

   </div>
   <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                <h2 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h2>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
    </>
  );
};

export default SimpleInterestCalculator;
